/**
 * Formats a date string into a relative time format (e.g., "3 days ago", "1 hour ago")
 * @param {string} dateString - ISO date string
 * @returns {string} Relative time string
 */
export function getRelativeTimeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const secondsAgo = Math.floor((now - date) / 1000);

  // Handle future dates
  if (secondsAgo < 0) {
    return "just now";
  }

  // Less than a minute
  if (secondsAgo < 60) {
    return "just now";
  }

  // Less than an hour
  if (secondsAgo < 3600) {
    const minutes = Math.floor(secondsAgo / 60);
    return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  }

  // Less than a day
  if (secondsAgo < 86400) {
    const hours = Math.floor(secondsAgo / 3600);
    return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  }

  // Less than a week
  if (secondsAgo < 604800) {
    const days = Math.floor(secondsAgo / 86400);
    return days === 1 ? "1 day ago" : `${days} days ago`;
  }

  // Less than a month
  if (secondsAgo < 2592000) {
    const weeks = Math.floor(secondsAgo / 604800);
    return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
  }

  // Less than a year
  if (secondsAgo < 31536000) {
    const months = Math.floor(secondsAgo / 2592000);
    return months === 1 ? "1 month ago" : `${months} months ago`;
  }

  // More than a year
  const years = Math.floor(secondsAgo / 31536000);
  return years === 1 ? "1 year ago" : `${years} years ago`;
}

// Usage example:
// const datePosted = "2024-11-22T10:24:50.100Z";
// const timeAgo = getRelativeTimeAgo(datePosted);
